import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Input } from "reactstrap";

export default class ModalCoustom extends React.Component {
  state = {
    obs: "",
  };

  isDisabled = () => this.state.obs === "";

  render() {
    let user = { cpf: null };
    if (this.props.body) {
      user = this.props.body.user ? this.props.body.user : { cpf: null };
    } else {
      return null;
    }

    return (
      <Modal isOpen={this.props.show}>
        <ModalHeader>
          <h3>Verifique os dados:</h3>
        </ModalHeader>
        <ModalBody>
          <p>{this.props.message}</p>
          <p>
            <strong>Imei:</strong> {this.props.body.imei}
          </p>
          <p>
            <strong>B.O:</strong> {this.props.body.numero_bo}
          </p>
          <p>
            <strong>Serial:</strong> {this.props.body.serial}
          </p>
          <p>
            <strong>CPF:</strong> {user.cpf}
          </p>
          <p>
            <strong>Email:</strong> {user.email}
          </p>
          <label htmlFor="obs_confirmacao">
            <strong>Motivo</strong>
          </label>
          <Input
            type="textarea"
            id="obs_confirmacao"
            onChange={(e) => this.setState({ obs: e.target.value })}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color={this.isDisabled() ? "default" : "primary"}
            onClick={() =>{
              this.props.indeferirBO({ ...this.props.body, obs_confirmacao: this.state.obs });
              this.props.cancel();
            }}
            disabled={this.isDisabled()}
          >
            Confirmar
          </Button>
          <Button
            color="danger"
            onClick={() => {
              this.props.cancel();
              this.setState({ obs: "" });
            }}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/hoc/ModalCustom.js